import React, { useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Tag from "sushiweb/Tag";
import Table from "../../Common/Table";
import * as UserActions from "../../../store/actions/User";
import styled from "styled-components";
import grey from "sushiweb/tokens/color/grey";
import green from "sushiweb/tokens/color/green";
import Button from "sushiweb/Button";
import TableFields from "../../../constants/ConfigChangeLog/ConfigChangeLogTableFields.json";
import * as ConfigChangeLogActions from "../../../store/actions/ConfigChangeLog";
import * as GenSettingActions from "../../../store/actions/GenSetting";
import * as CityPropertyActions from "../../../store/actions/CityProperty";
import ChangeLogDiffModal from "../ChangeLogDiffModal";
import JsonDiffReact from "jsondiffpatch-for-react";
import { isEmpty, isValNull } from "../../../utils/index";
import ErrorMsgs from "../../../constants/Errors.json";
import yellow from "sushiweb/tokens/color/yellow";
import { getPath } from "../../../utils";
import Modal from "sushiweb/Modal";
import JSONInput from "react-json-editor-ajrm";
import locale from "react-json-editor-ajrm/locale/en";
import black from "sushiweb/tokens/color/black";

const ChangeLogList = (props) => {
  const [modalState, setModalState] = useState(false);
  const [activeLog, setActiveLog] = useState(null);
  const [activeVal, setActiveVal] = useState("");
  const {
    Logslist,
    Source,
    activeCityProperty,
    activeGenSetting,
    setLogsList,
    Key,
  } = props;

  const handleClick = (type, log) => {
    setActiveLog(log);
    setModalState(type);
  };

  const handleRevert = (log) => {
    if (Source === "General Setting") {
      activeGenSetting.value = log.old_value;
      props
        .updateGenSetting(activeGenSetting)
        .then(() => {
          props.getGenSettingChangeLog().then((response) => {
            setLogsList(response.change_logs);
          });
        })
        .catch((err) => {
          props.setStatus({
            type: "error",
            message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
          });
        });
    } else {
      activeCityProperty.value = log.old_value;
      if (isEmpty(activeCityProperty.value)) {
        activeCityProperty.value = { rules: [] };
      }
      props
        .updateCityProperty(activeCityProperty.id, activeCityProperty)
        .then(() => {
          props.resetState({ state: "CityPropertyChangeLog" });
          props
            .getCityPropertyChangeLog(
              {},
              {},
              parseInt(activeCityProperty.city_id)
            )
            .then((response) => {
              setLogsList(response.change_logs);
            })
            .catch((err) => {
              props.setStatus({
                type: "error",
                message:
                  typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
              });
            });
        })
        .catch((err) => {
          props.setStatus({
            type: "error",
            message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
          });
        });
    }
  };

  const handleModalClose = () => {
    setActiveLog(null);
    setActiveVal("");
    setModalState(false);
  };

  const viewJsonValue = (val, type) => {
    setActiveVal(val);
    setModalState(type);
  };

  const getFieldValue = (log, key, idx) => {
    switch (key) {
      case "old_value":
        return (
          <span
            onClick={() =>
              viewJsonValue(getPath(log, key, "null"), "old_value")
            }
            className="view-options cursor-pointer"
          >
            {"old_value"}
          </span>
        );
      case "updated_value":
        return (
          <span
            onClick={() =>
              viewJsonValue(getPath(log, key, "null"), "updated_value")
            }
            className="view-options cursor-pointer"
          >
            {"updated_value"}
          </span>
        );
      case "difference":
        var old_value = log.old_value;
        var updated_value = log.updated_value;
        return <JsonDiffReact left={old_value} right={updated_value} />;

      case "action_by":
        return log[key];
      case "event":
        const label_ = log[key];
        const bgColor_ =
          label_ === ("create" || label_ === "update") ? green.z500 : grey.z500;
        return (
          <EventTag
            type="tag"
            label={label_}
            tagWidth="55px"
            bgColor={bgColor_}
          ></EventTag>
        );
      case "timestamp":
        const d = new Date(log[key]);
        let date =
          d.getHours() + ":" + d.getMinutes() + ", " + d.toDateString();
        return date;
      case "field":
        const value = log[key];
        const clr = value == "temp_val" ? yellow.z500 : grey.z500;
        return (
          <EventTag
            type="tag"
            label={value}
            tagWidth="auto"
            bgColor={clr}
          ></EventTag>
        );
      case "actions":
        const isDisabled =
          (log["old_value"] != null && isValNull(log["old_value"])) ||
          Key != "relaxation_configuration"
            ? true
            : false;
        return (
          <div>
            <ChangeLogButton
              size="small"
              onClick={() => handleClick("CHangeLogsDiffModal", log)}
              appearance="outline"
              className="shushi-btn"
              id="changes"
            >
              Changes
            </ChangeLogButton>
            <ChangeLogButton
              className="shushi-btn"
              size="small"
              disabled={isDisabled}
              appearance="outline"
              onClick={() => handleRevert(log)}
              id="revert-button"
            >
              Revert
            </ChangeLogButton>
          </div>
        );
      default:
        return getPath(log, key, "NA");
    }
  };
  const getModal = () => {
    switch (modalState) {
      case "CHangeLogsDiffModal":
        return (
          <ChangeLogDiffModal
            old_value={activeLog.old_value}
            updated_value={activeLog.updated_value}
            modalState={modalState}
            handleModalClose={handleModalClose}
            Source={Source}
          />
        );
      case "old_value":
      case "updated_value":
        return (
          <Modal
            visible={!!modalState}
            onClose={handleModalClose}
            type="large"
            showCloseIcon={true}
            slideOnMobile
            isCentered
            padding="2rem"
            preventFocus
            id="JsonViewModal"
          >
            {typeof activeVal === "object" ? (
              <div>
                <JSONInput
                  id="jsonInput"
                  placeholder={activeVal}
                  locale={locale}
                  height="auto"
                  width="auto  "
                  viewOnly={true}
                  colors={{
                    string: "#FA7921",
                    number: "#50B547",
                    background: "#00000000",
                    keys: "#1E1E1E",
                    default: black,
                  }}
                  confirmGood={false}
                  theme="light_mitsuketa_tribute"
                />
              </div>
            ) : (
              <p style={{ fontSize: "1rem" }} className="medium">
                {activeVal}
              </p>
            )}
          </Modal>
        );
    }
  };

  return (
    <TableView>
      <Table
        list={Logslist}
        getFieldValue={getFieldValue}
        fields={TableFields}
      />
      {!!modalState && getModal()}
    </TableView>
  );
};

const ChangeLogButton = styled(Button)`
  padding: 8px;
  width: 8rem;
  height: 30%;
`;

const EventTag = styled(Tag)`
    margin: 8px,
    height: 30%,
`;

const TableView = styled.section`
  height: calc(100vh - 200px);
`;
const mapStateToProps = (state) => {
  const { ConfigChangeLog, CityProperty, GenSetting } = state;
  return {
    CityPropertyChangeLog: ConfigChangeLog.CityPropertyChangeLog,
    GenSettingChangeLog: ConfigChangeLog.GenSettingChangeLog,
    activeCityProperty: CityProperty.activeCityProperty,
    activeGenSetting: GenSetting.activeGenSetting,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getCityPropertyChangeLog: bindActionCreators(
      ConfigChangeLogActions.getCityPropertyChangeLog,
      dispatch
    ),
    getGenSettingChangeLog: bindActionCreators(
      ConfigChangeLogActions.getGenSettingChangeLog,
      dispatch
    ),
    updateGenSetting: bindActionCreators(
      GenSettingActions.updateGenSetting,
      dispatch
    ),
    updateCityProperty: bindActionCreators(
      CityPropertyActions.updateCityProperty,
      dispatch
    ),
    resetState: bindActionCreators(ConfigChangeLogActions.resetState, dispatch),
    setStatus: bindActionCreators(UserActions.setStatus, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ChangeLogList);
